import React from "react"
import { graphql } from 'gatsby'
import PageContainer from "../containers/PageContainer"
import HeadData from "../data/HeadData"
import PageHeaderImageBg from '../headers/PageHeaderImageBg'
import PageHeaderText from "../headers/PageHeaderText"
import HeaderNav from "../navigation/HeaderNav"
import PagePaymentSection from "../sections/PagePaymentSection"
import HomeAffiliationSection from "../sections/HomeAffiliationSection"
import CTASection from "../sections/CTASection"

export default ({ data }) => (
  <PageContainer>
    <HeadData
      title='Online Payment'
    />

    <PageHeaderImageBg imageData={data.imageBg.childImageSharp.fluid}>
      <HeaderNav />
      <PageHeaderText
        title='Online Payment'
      />
    </PageHeaderImageBg>

    <PagePaymentSection />

    <HomeAffiliationSection />

    <CTASection />
  </PageContainer>
)

export const query = graphql`
  query PaymentPageQuery {
    imageBg: file(relativePath: { eq: "services/home-service-residential-bg.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1280) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`